export default class File {
  constructor() {
    this.file = ''
  }
}
